import React, { useCallback } from "react";
import { connect } from "react-redux";

import Tabs from "antd/es/tabs";
import { defineMessages, useIntl } from "react-intl";

import MultiPinGroupMode from "@app/scene/map/enums/MultiPinGroupMode";
import { fetchGroupRecords } from "@app/scene/map/store/groupMode/actions";
import { setMultiPinGroupMode } from "@app/scene/map/store/mapMode/actions";
import { getMultiPinGroupMode } from "@app/scene/map/store/mapMode/selectors";
import { RootState } from "@app/store/rootReducer";

const messages = defineMessages({
  [MultiPinGroupMode.OUTSIDE_GROUP]: {
    id: "map.recordsList.groupMultiPin.mode.outside",
    defaultMessage: "Not in Group",
    description: "Group multi-pin mode - not in group",
  },
  [MultiPinGroupMode.WITHIN_GROUP]: {
    id: "map.recordsList.groupMultiPin.mode.within",
    defaultMessage: "Within Group",
    description: "Group multi-pin mode - within group",
  },
});

interface Props {
  fetchRecords: typeof fetchGroupRecords.request;
  mode?: MultiPinGroupMode;
  setMultiPinGroupMode: typeof setMultiPinGroupMode;
}

const GroupMultiPinMode: React.FC<Props> = ({ fetchRecords, mode, setMultiPinGroupMode }) => {
  const intl = useIntl();

  const handleTabClick = useCallback(
    (key: string) => {
      setMultiPinGroupMode(key as MultiPinGroupMode);
      fetchRecords({});
    },
    [fetchRecords, setMultiPinGroupMode]
  );

  return (
    <Tabs activeKey={mode} onTabClick={handleTabClick}>
      <Tabs.TabPane
        key={MultiPinGroupMode.WITHIN_GROUP}
        tab={intl.formatMessage(messages[MultiPinGroupMode.WITHIN_GROUP])}
      />
      <Tabs.TabPane
        key={MultiPinGroupMode.OUTSIDE_GROUP}
        tab={intl.formatMessage(messages[MultiPinGroupMode.OUTSIDE_GROUP])}
      />
    </Tabs>
  );
};

const mapStateToProps = (state: RootState) => ({
  mode: getMultiPinGroupMode(state),
});

const mapDispatchToProps = {
  fetchRecords: fetchGroupRecords.request,
  setMultiPinGroupMode,
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupMultiPinMode);
